import React, { useState, useContext, useEffect } from 'react';

import '/node_modules/react-grid-layout/css/styles.css';
import '/node_modules/react-resizable/css/styles.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import AppContext from '../Hooks/AppContext';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

const variantOptions = [
  {value: 'h1'       , label: 'Header 1'  },
  {value: 'h2'       , label: 'Header 2'  },
  {value: 'h3'       , label: 'Header 3'  },
  {value: 'h4'       , label: 'Header 4'  },
  {value: 'h5'       , label: 'Header 5'  },
  {value: 'h6'       , label: 'Header 6'  },
  {value: 'subtitle1', label: 'Subtitlu 1'},
  {value: 'subtitle2', label: 'Subtitlu 2'},
  {value: 'body1'    , label: 'Continut 1'},
  {value: 'body2'    , label: 'Continut 2'},
  {value: 'button'   , label: 'Buton'     },
  {value: 'caption'  , label: 'Observatie'},
  {value: 'overline' , label: 'Overline'  },
];
const alignOptions = [
  {value: 'left'   , label: 'Stanga'      },
  {value: 'center' , label: 'Centru'      },
  {value: 'right'  , label: 'Dreapta'     },
  {value: 'justify', label: 'Pagina plina'},
];

const FormElementText = props => {
  /**
   * Constants
   */

  /**
   * States
   */
  const [isLoaded, setIsLoaded] = useState(false);
  const [defaultData, setDefaultData] = useState(null);
  const [data, setData] = useState(null);
  const [notification, setNotification] = useState(null);

  /**
   * Hooks
   */
  const ac = useContext(AppContext);

  /**
   * Effects
   */
  useEffect(() => {
    if (JSON.stringify(props.value) !== JSON.stringify(defaultData)) {
      setDefaultData(props.value);
      setData(props.value);

      setIsLoaded(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    if (!isLoaded) return;

    let message = null;

    message = message !== null ? message : data.value === '' ? 'Nu ati completat textul' : message;

    message = message !== null ? message : JSON.stringify(data) === JSON.stringify(defaultData) ? 'Nu ati efectuat nici o modificare' : null;

    setNotification(message);
  }, [isLoaded, defaultData, data]);

  /**
   * Getters
   */

  /**
   * Handlers
   */
  const handleDataChange = (property = null, index = null) => evt => {
    let mods = {};
    switch (evt.target.name) {default: break;}

    let value = null;

    switch (evt.target.type) {
      case 'checkbox':
        value = evt.target.checked;
        break;
      default:
        value = evt.target.value;
    }

    if (property) {
      setData(prevState => ({
        ...prevState,
        [property]: index === null
          ? {...prevState[property], [evt.target.name]: value}
          : Object.assign([], prevState[property], {[index]: {
            ...prevState[property][index],
            [evt.target.name]: value,
          }}),
        ...mods,
      }));
    } else {
      setData(prevState => ({
        ...prevState,
        [evt.target.name]: value,
        ...mods,
      }));
    }
  };

  const handleClose = (evt, reason) => {
    switch (reason) {
      case 'backdropClick':
        break;
      case 'escapeKeyDown':
        if (JSON.stringify(data) === JSON.stringify(defaultData)) {
          handleCancel()();
        }
        break;
      default: break;
    }
  };

  const handleCancel = () => () => props.onCancel();
  const handleConfirm = () => () => {
    props.onConfirm(data);
  };

  /**
   * Renderer
   */
  if (!isLoaded) {
    return (
      <Backdrop open sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  }

  return (
    <Dialog maxWidth={'sm'} fullWidth open keepMounted
      disableEscapeKeyDown={ac.isLoading}
      onClose={handleClose}
    >
      {/**
       * Title
      */}
      <DialogTitle>Proprietati componenta formular tip {data.type}</DialogTitle>

      {/**
       * Content
      */}
      <DialogContent>
        <DialogContentText>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField required autoFocus
                disabled={ac.isLoading}
                label='Text'
                placeholder='Text'
                name='value'
                value={data.value}
                onChange={handleDataChange()}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField select
                disabled={ac.isLoading}
                label='Varianta'
                placeholder='Varianta'
                name='variant'
                value={data.props.variant}
                onChange={handleDataChange('props')}
              >
                {variantOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}><Typography variant={option.value}>{option.label}</Typography></MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField select
                disabled={ac.isLoading}
                label='Aliniere'
                placeholder='Aliniere'
                name='align'
                value={data.props.align}
                onChange={handleDataChange('props')}
              >
                {alignOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>

      {/**
       * Notification message
       */}
      <DialogContent>
        <DialogContentText color='error' sx={{visibility: Boolean(notification) ? 'initial' : 'hidden'}}>
          {Boolean(notification) ? notification : 'Totul pare OK!'}
        </DialogContentText>
      </DialogContent>

      {/**
       * Actions
      */}
      <DialogActions>
        <Button disabled={ac.isLoading || Boolean(notification)} onClick={handleConfirm()}>Salveaza</Button>
        <Button variant='text' color='inherit' disabled={ac.isLoading} onClick={handleCancel()}>Renunta</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormElementText;